export default "__VITE_ASSET__GVFDnc$$__"